import styles from './WorkspaceTilesSkeleton.module.scss'

export default function WorkspaceTilesSkeleton() {
  return (
    <>
      <div className={styles.tile} aria-hidden="true" />
      <div className={styles.tile} aria-hidden="true" />
    </>
  )
}
